<div>
  <div class="example-container" [style.borderTop]="!evnProd?'10px solid #4EC33D':'0'">
    <mat-sidenav-container class="sidenav-all">
      <router-outlet />
    </mat-sidenav-container>
  </div>
</div>